import Loader from '@fava/Components/Loader/Loader';
import useAccount from '@fava/Hooks/useAccount';
import {
  getUserAdminInfo,
  getUserAdminStructure,
  getUserStudent,
  getUserTeacher,
} from '@fava/Store/Thunks/fetchAccount';
import { apiUrl, routeAdminPrefix, routeStudentPrefix } from '@fava/Utils';
import { LocalStorageUtils } from '@fava/Utils/localStorage';
import configRole from '@fava/Utils/role';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { login } from '../../Services/user';

const ProxyNinjaCallback: React.FC = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const { push } = useHistory();
  const account = useAccount();

  useEffect(() => {
    const processCallback = async () => {
      try {
        // 1. Check query params first (response_mode=query flow)
        const searchParams = new URLSearchParams(window.location.search);
        const session = searchParams.get('session');
        const id = searchParams.get('id');
        const email = searchParams.get('znak');
        let code = searchParams.get('code');
        let state = searchParams.get('state');

        // If we have session/id/email in query params, it's the normal redirect flow
        if (session && id && email) {
          await doLogin(session, id, email);
          return;
        }

        // 2. Check hash fragment (response_mode=fragment flow from Proxy Ninja)
        const { hash } = window.location;
        if (hash) {
          const hashParams = new URLSearchParams(hash.substring(1));
          code = code || hashParams.get('code');
          state = state || hashParams.get('state');
        }

        if (!code) {
          console.error('[ProxyNinja Callback] No code found in query params or hash fragment');
          push('/error');
          return;
        }

        // 3. Exchange code for tokens via backend
        const response = await fetch(`${apiUrl}/api/proxy-ninja/token-exchange`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code, state }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          if (errorData.redirect) {
            window.location.href = errorData.redirect;
            return;
          }
          console.error('[ProxyNinja Callback] Token exchange failed:', errorData);
          push('/error');
          return;
        }

        const data = await response.json();
        await doLogin(data.session, String(data.id), data.email);
      } catch (err) {
        console.error('[ProxyNinja Callback] Error:', err);
        push('/error');
      } finally {
        setIsLoading(false);
      }
    };

    const doLogin = async (session: string, id: string, email: string) => {
      LocalStorageUtils.clear();

      const response = await login({
        email,
        identifier: email,
        password: 'intimedgar77X/*',
      } as any);

      LocalStorageUtils.setItem('user_infos', JSON.stringify(response?.data?.user));
      localStorage.setItem('session', session);
      LocalStorageUtils.setItem('user_token', response?.data?.jwt);

      const role = configRole[response?.data?.user.role.name];
      account.setData(response?.data?.user);
      account.setType(role || '');

      switch (response?.data?.user?.role?.id) {
        case 1:
          push(`/${routeStudentPrefix}/programs`);
          dispatch(getUserStudent(response?.data?.user?.id) as any);
          window.location.reload();
          break;
        case 4:
          dispatch(getUserAdminInfo(response?.data?.user?.id) as any);
          push(`/${routeAdminPrefix}/account`);
          break;
        case 6:
          dispatch(getUserTeacher(response?.data?.user?.id) as any);
          push(`/teacher/account`);
          break;
        case 3:
          dispatch(getUserAdminStructure(response?.data?.user?.id) as any);
          push(`/admin-structure/account`);
          break;
        default:
          console.log('[ProxyNinja Callback] Unknown role:', response?.data?.user?.role?.id);
      }
    };

    processCallback();
  }, []);

  return <Loader />;
};

export default ProxyNinjaCallback;
